<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wXhH98/tc-custom/9780795340079.jpg?1726519331181" alt="This image is the cover for the book Undercurrents"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Undercurrents
      </h1>
      <p class="bookDescription body article font2">
        <b>“Outstanding . . . An attention to forensic and procedural detail unmatched outside of Ed McBain’s best . . . A read-through-the-night story” (<i>Kirkus Reviews</i>).</b><br/>  <br/> Police Sgt. Lou Boldt heads a special task force within Seattle’s homicide bureau. His job: find and stop the Cross Killer, a twisted, perverse serial murderer who has eluded police for six months and paralyzed the city. But when a body washes up on the shore of Puget Sound, Boldt thinks the killer has finally made a mistake. This body shows some of the work of the Cross Killer—but a job badly botched. Did this woman die while trying to escape? Did she knowingly jump in the water to preserve a clue? And is she now desperately trying to tell Boldt something? With the help of the alluring Daphne Matthews, a police psychologist, Boldt must piece together the complex puzzle.<br/>  <br/> From the #1 <i>New York Times</i>–bestselling author of the Chris Klick series and the Walt Fleming series, this thriller reveals “an authentic feeling for police investigation and forensic medicine, and a remarkable insight and understanding of the motivations of the criminal mind” (<i>Publishers Weekly</i>).<br/>  <br/> “Pearson has done well at putting together the grueling steps in an investigation . . . His characters are believable, and it’s an enjoyable entertainment.” —<i>Chicago Tribune</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ridley Pearson
      </h2>
      
      <p class="authorDescription body article">Ridley Pearson is a <I>New York Times&ndash;</I>bestselling author with over twenty-four&#160;novels published. His work is extremely diverse, from children&rsquo;s fiction to crime novels, paranormals and adventure; his novels often incorporate a compelling combination of realistic high-tech forensic wizardry and hair-trigger suspense. One of his best-known crime novels, <I>Undercurrents,</I> contained cutting-edge forensic ideas that helped solve a real-life homicide case. Another, <I>Chain of Evidence, </I>was the first to raise the possibility of a &ldquo;crime gene&rdquo;&mdash;which later became the focus of a high-profile genetics conference. He has published several popular crime series featuring recurring characters, as well as standalone novels under his own name and the pseudonyms Joyce Reardon, PhD&#160;and Wendell McCall. A new thriller, <I>The Red Room, </I>featuring John Knox, will be coming out in June 2014. Pearson was the first American to receive the Raymond Chandler Fulbright fellowship at Oxford University, the site of his research for bestselling novels <I>No Witnesses</I> and <I>The Angel Maker. </I>He was also a founding member and bass player for the Rock Bottom Remainders, a band comprised of bestselling authors including Dave Barry and Stephen King.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      RosettaBooks LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3f898ac0